import Reflux from 'reflux'

export default Reflux.createActions([
	'get'
])



// WEBPACK FOOTER //
// ./src/actions/recipes.js